import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../core/modules/shared.module';
import {AuthGuard} from '../../../data/services/authGuard';

import {TwoFactorComponent} from './two-factor.component';

const routes = [{
  path: 'two-factor',
  component: TwoFactorComponent,
  canActivate: [AuthGuard]
}];

@NgModule({
  declarations: [TwoFactorComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [TwoFactorComponent]
})
export class TwoFactorModule {}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/two-factor/two-factor.module.ts